//============================================================================================================
//  GLOBAL VARS
//============================================================================================================

var fancyOverlayColor = '#fff';
var fancyOverlayOpacity = 0.75;
var rating = 4.3;
var sidebar;

//============================================================================================================
//  DOCUMENT READY
//============================================================================================================
$(document).ready(function () {
    
    initMyAccountFunctions();
    initCheckoutFunction();

    function initMyAccountFunctions() {
        if (typeof (InitMyAccountFunctions) == "function")
            InitMyAccountFunctions();
    };

    function initCheckoutFunction() {
        if (typeof (InitCheckoutFunctions) == "function")
            InitCheckoutFunctions();
    };

    $('*[data-numbers-allowed="true"]').keyup(function () {
        var value = this.value.replace(/[^0-9\.,]/g, '');

        if (this.value != value) {
            this.value = value;
        }
    });

    initSideStickyColumn();
    initTooltips();
    
    var hasCookie = Cookies.get('InlineAdmin') || null;

    if (hasCookie) {
        $('html').addClass('has-inline-admin');
    } else {
        $(".js-change-inline-admin-box").remove();
    }


    Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, 'custom', function (envelope) {
        model = envelope.message.data.model;

        if (__.contains(model.Roles, 55)) { 
            $(".js-change-inline-admin-box.dealer-issue").closest('.inline-admin-anchor').addClass('active');
            $(".js-change-inline-admin-box.importer-issue").remove();

        } else if (__.contains(model.Roles, 54)) {
            $(".js-change-inline-admin-box.importer-issue").closest('.inline-admin-anchor').addClass('active');
            $(".js-change-inline-admin-box.dealer-issue").remove();
        }
   });

    $(".js-change-inline-admin-box.importer-issue .js-inline-admin-setting").fancybox({ type: 'iframe', baseClass: "inline-admin-popup", toolbar: false, smallBtn: true });
    $(".js-change-inline-admin-box.dealer-issue .js-inline-admin-setting").fancybox({ type: 'iframe', baseClass: "inline-admin-popup", toolbar: false, smallBtn: true });

    (function replaceFooterLinksTarget() { //Footer external links target
        var $footerMenu6 = $('[data-class="vcfg_glb_menu_footer_column6"]');
        var $links = $('a', $footerMenu6);
        $links.each(function (index, element) {
            var $this = $(element);
            $this.attr('target', '_blank')
        });
    })();

    initScripts('general'); //General Scripts that require no consent

    // Your code here
    document.body.addEventListener("click", function (event) {
        if (event.target.closest("#ot-sdk-btn")) {            
            $.fancybox.open({
                src: '#cookies-modal-id',
                opts: {
                    toolbar: false,  // Hides the whole top bar (including the close button)
                    smallBtn: false  // Hides just the small X button in the corner
                }
            });            
        }
    });
});

//============================================================================================================
//  DOCUMENT READY END
//============================================================================================================

window.openManageCookiesPopUp = function () {
    // This opens the OneTrust preference center modal
    if (typeof Optanon !== "undefined" && typeof Optanon.ToggleInfoDisplay === "function") {
        Optanon.ToggleInfoDisplay();
    }

    //we can also do this , assign all at window
    //if (window.Optanon && typeof window.Optanon.ToggleInfoDisplay === "function") {
    //    window.Optanon.ToggleInfoDisplay();
    //    return;
    //}

    //Open venddalion consents popup (Spain)
    if (skodaVariables.countryCode == "es") {
        $.fancybox.open({
            src: '#cookies-modal-id',
            opts: {
                toolbar: false,  
                smallBtn: false 
            }
        });
    }  
};
function numbersOnly(event) {
    // left arrow, right arrow, tab
    if (event.keyCode == 37 || event.keyCode == 39 || event.keyCode == 9) {
    }
    else if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 36 || event.keyCode == 35) { // delete, backspace, home, end
    }
    else {
        if (event.keyCode < 95) {
            if (event.keyCode < 48 || event.keyCode > 57) // numbers
                event.preventDefault();
        }
        else {
            if (event.keyCode < 96 || event.keyCode > 105) // keypad
                event.preventDefault();
        }
    }
}

function preventSpecialCharacter(e) {
    var shiftPressed = e.shiftKey;
    var keyCode = e.keyCode;

    if (shiftPressed) {
        // In Order: '<', '>', '#', '&', '%', '{', '}'
        if (keyCode == 188 || keyCode == 190 || keyCode == 51 || keyCode == 55 || keyCode == 53 || keyCode == 219 || keyCode == 221)
            e.preventDefault();
    } else {
        // In Order: '/', '[', ']', '/(numPad)', '&', '%'
        if (keyCode == 191 || keyCode == 219 || keyCode == 221 || keyCode == 111)
            e.preventDefault();
    }
};

function encodeHtmlFromData(formData, key) {
    var value = formData[key];

    if (typeof value === 'string' && value.length > 0) {
        value = value.replace(/</g, "&lt;").replace(/>/g, "&gt;");
        formData[key] = value;
    }
};

function removeWhiteSpaces(input) {
    //remove white spaces from postal code
    var val = input.val();

    if (val.length > 0) {
        val = val.replace(/\s/g, '');
        input.val(val);
    }
};

function phoneGROnly(event) {
    numbersOnly(event);
    if ($(event.currentTarget).val().length > 9)
        // delete, backspace, home, end, left arrow, right arrow, tab
        if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 36 || event.keyCode == 35 || event.keyCode == 37 || event.keyCode == 39 || event.keyCode == 9) { }
        else { event.preventDefault(); }
}

function stickyContainer(container, cssClass) {
    //Sticky container on scroll

    //Call Example
    //stickyContainer($('.header-region'), 'sticky');

    var containerHeight = container.height();
    var scrlTop = $(window).scrollTop();
    container.before("<div class='spacer'></div>");
    var spacer = $('.spacer');

    //Initialize
    if (scrlTop >= containerHeight) {
        spacer.height(containerHeight);
        container.addClass(cssClass);
    }
    else {
        spacer.height(0);
        container.removeClass(cssClass);
    }

    /* respond to scroll event */
    $(window).scroll(function () {
        scrlTop = $(window).scrollTop();
        if (scrlTop >= containerHeight) {
            spacer.height(containerHeight);
            container.addClass(cssClass);
        }
        else {
            spacer.height(0);
            container.removeClass(cssClass);
        }
    });
}

function scroll_to_class(element_class, removed_height) {
    var scroll_to = $(element_class).offset().top - removed_height;
    if ($(window).scrollTop() != scroll_to) {
        $('html, body').stop().animate({
            scrollTop: scroll_to
        }, 0);
    }
}

function hideOnScrollDown(container, cssClass) {
    // Hide container on on scroll down

    //Call Example
    //hideOnScrollDown($('.header-region'), 'hidden');

    var containerHeight = container.height();

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;

    $(window).scroll(function (event) {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            var st = $(this).scrollTop();
            // Make sure they scroll more than delta
            if (Math.abs(lastScrollTop - st) <= delta)
                return;

            // If they scrolled down and are past the navbar, add class .nav-up.
            // This is necessary so you never see what is "behind" the navbar.
            if (st > lastScrollTop && st > containerHeight) {
                // Scroll Down
                container.addClass(cssClass);
            } else {
                // Scroll Up
                if (st + $(window).height() < $(document).height()) {
                    container.removeClass(cssClass);
                }
            }

            lastScrollTop = st;
            didScroll = false;
        }
    }, 250);

}

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function isTouch() {
    return ($('.touch').length > 0);
}

function importEmailForRegistration() {

    var email = sessionStorage.getItem('registrationEmail');

    if ($('.x-registration-form').length > 0 && email) {
        $('.x-registration-form input[name="email"]').val(email);
    }

    if ($('.x-registration-b2b-form').length > 0 && email) {
        $('.x-registration-b2b-form input[name="email"]').val(email);
    }

}

function initSideStickyColumn() {

    var stickyContainer = $('.side-content.js-sticky-column');

    if (stickyContainer.length < 1) return;

    var stickyConfig = {};
    if (isTouch()) {
        stickyConfig = {
            topSpacing: 0,
            bottomSpacing: 0,
            containerSelector: '.sticky-full',
            innerWrapperSelector: '.inner-sticky-column',
            resizeSensor: true,
            minWidth: 960
        };

    } else { 
        stickyConfig = {
            topSpacing: stickyContainer.data('top-spacing') || 50,
            bottomSpacing: stickyContainer.data('bottom-spacing') || 0,
            containerSelector: '.sticky-full',
            innerWrapperSelector: '.inner-sticky-column',
            resizeSensor: true,
            minWidth: 960

        };

    }

    sidebar = new StickySidebar('.side-content.js-sticky-column', stickyConfig);
}

function initTooltips() {
    var $wrapper = $('.form-row .tooltip-info-wrapper');

    if ($wrapper.length < 1)
        return;

    $('.info-btn', $wrapper).click(function () {
        var tooltipBox = $(this).siblings('.info-tooltip');
        $('.info-tooltip', $wrapper).not(tooltipBox).hide();
        tooltipBox.toggle();
    });

    $(document).on('click', function (e) {
        if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
            $('.info-tooltip', $wrapper).hide();
        }
    });
}

// in case of pages that need to load inside an iframe
// and call parent vendd js to execute some actions
// make sure that parent vendd iframe is accessible
function getParentOrSelfVendd() {
    try {

        if (typeof parent.Vendd != "undefined")
            return parent.Vendd;
    }
    catch (error) { }

    return Vendd;
}

function isElementInViewport(el) {

    if (el.length <= 0)
        return false;
    //special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
}

function isElementPartialyInViewport(el, minSize = { height: 0, width: 0 }) { // minSize = Minimum viewable size of element in viewport

    if (el.length <= 0)
        return false;
    //special bonus for those using jQuery
    if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        (rect.top + minSize.height) <= (window.innerHeight || document.documentElement.clientHeight) &&
        (rect.left + minSize.width) <= (window.innerWidth || document.documentElement.clientWidth)
    );
} 
 
//============================================================================================================

function UpdateQueryString(key, value, url) {

    if (!url) url = window.location.href;

    // dirty fix for new url rewriter, remove page number to go back to page 1
    url = url.replace(/\/{1}p{1}[0-9]+/, '');


    //Vendd.MessageBus.publishAsync(wrapper, new Vendd.FilterProduct.Messages.GetNextFilter());

    var re = new RegExp("([?|&])" + key + "=.*?(&|#|$)", "gi");

    if (url.match(re)) {
        if (value)
            var value = url.replace(re, '$1' + key + "=" + value + '$2');
        else
            var value = url.replace(re, '$2');

        if (value.indexOf('?') == -1) { // convert first paramter separator to query params separator
            var pos = value.indexOf('&');
            if (pos != -1) // has at least one parameter
                value = value.substring(0, pos) + '?' + value.substring(pos + 1, value.length);
        }
        return value;
    }
    else {
        if (value) {
            var separator = url.indexOf('?') !== -1 ? '&' : '?',
                hash = url.split('#');
            url = hash[0] + separator + key + '=' + value;
            if (hash[1]) url += '#' + hash[1];
            return url;
        }
        else
            return url;
    }
};

function getQueryStringValueByName(name) {
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regexS = "[\\?&]" + name + "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(window.location.search);
    if (results == null)
        return "";
    else
        return decodeURIComponent(results[1].replace(/\+/g, " "));
}

function initScripts(type) { //Initialize scripts by type (general, analytics, marketing)
    if (!type || (type !== 'general' && type !== 'analytics' && type !== 'marketing'))
        return console.log('Invalid "type" argument passed at initScripts function');

    var scripts = skodaVariables && skodaVariables.scripts && skodaVariables.scripts[type];
    if (scripts.loaded) return;

    if (type === 'analytics') {
        scripts.ga4 = ga4Code();
        scripts.fbPixel = fbPxlCode();
        if (skodaVariables.gaId && scripts.ga4) insert('head', scripts.ga4);
        if (skodaVariables.fbId && scripts.fbPixel) insert('head', scripts.fbPixel);
    }

    if (scripts.globalHead) insert('head', scripts.globalHead);
    if (scripts.dealerHead) insert('head', scripts.dealerHead);
    if (scripts.globalBody) insert('body', scripts.globalBody);
    if (scripts.dealerBody) insert('body', scripts.dealerBody);
    scripts.loaded = true;

    //Predefined scripts for GA4 and FB Pixel
    function ga4Code() {
        return `
            <!-- GA4 -->
            <script async src="https://www.googletagmanager.com/gtag/js?id=${skodaVariables.gaId}"><\/script>
            <script>window.dataLayer=window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${skodaVariables.gaId}');<\/script>
            <!-- End GA4 -->
        `;
    }
    function fbPxlCode() {
        return `
            <!-- Meta Pixel Code -->
            <script>!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq("init", "${skodaVariables.fbId}");<\/script>
            <!-- End Meta Pixel Code -->
        `;
    }
}
function insert(position, elem) { //Parse HTML into the page - positions (head, body)
    if (!position || (position !== 'head' && position !== 'body'))
        return console.log('Invalid "position" argument passed at insert function');

    if (!elem)
        return console.log('Invalid "elem" argument passed at insert function');

    var range = document.createRange();
    var frag = range.createContextualFragment(elem);
    document[position].appendChild(frag);
    range.detach();
    frag = null;
}

//Listen for window post message
window.addEventListener('message', receiveMessage, false);
function receiveMessage(event) {
    if (event.data && event.data === 'Home') {
        window.location = "/";
    }
}
